import * as moment from "moment";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { getElasticSearchURLS } from "../../../selectors/enviromentSelectors";
import PersesSearchAPI from "../../../services/persesSearchService";
import { QUERY_STATUS } from "../../../utils/constants/dashboard/dashboardModuleConstants";
import { getMonthNameByDate, getMonthPeriodDates } from "../../../utils/helpers/dateHelper";
import { ONE_HOUR_MILLISECONDS } from "@utils/constants/react-query";

type unparsedData = {
  date: string;
  value: number;
};

type ParsedData = {
  name: string;
  value: number;
  previousValue?: number;
  filterPeriod: {
    fromDate: moment.MomentInput;
    toDate: moment.MomentInput;
  };
};

const parseLawsuitCounterResponse = (response: unparsedData[]): ParsedData[] => {
  const parsedResponse = response?.map((period: unparsedData, index: number) => {
    return {
      name: getMonthNameByDate(period.date),
      value: period.value,
      previousValue: response[index - 1]?.value ?? undefined,
      filterPeriod: getMonthPeriodDates(period.date),
    };
  });

  return parsedResponse;
};

// const parseLawsuitFilterRedirect = response => ({filterPeriod: })

const useLawsuitCounterQuery = (type: string): [string, ParsedData[], number, typeof refetch] => {
  const [lawsuitCount, setLawsuitCount] = useState<ParsedData[]>();
  const [status, setStatus] = useState(QUERY_STATUS.loading);

  const COMPONENT_DEFAULT_MONTH_RANGE = 3;

  const END_OF_THIS_MONTH = moment().endOf("month").format("YYYY-MM-DD");
  const START_OF_THREE_MONTHS_AGO = moment()
    .subtract(COMPONENT_DEFAULT_MONTH_RANGE - 1, "months")
    .startOf("month")
    .format("YYYY-MM-DD");

  const PERSES_CODED_URLS = useSelector(getElasticSearchURLS);
  const perses = new PersesSearchAPI(PERSES_CODED_URLS);

  const { data, isSuccess, isRefetching, isLoading, refetch, dataUpdatedAt } = useQuery(
    ["lawsuitCounter", { type, from: START_OF_THREE_MONTHS_AGO, to: END_OF_THIS_MONTH }],
    () => perses.getLawsuitCounterByMonth(type, START_OF_THREE_MONTHS_AGO, END_OF_THIS_MONTH),
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      staleTime: ONE_HOUR_MILLISECONDS,
    }
  );
  useEffect(() => {
    if (isLoading) return;
    if (isRefetching) {
      setStatus(QUERY_STATUS.refeching);
    }
    if (isSuccess) {
      const parsedData = parseLawsuitCounterResponse(data);
      setLawsuitCount(parsedData);
      setStatus(QUERY_STATUS.success);
    }
  }, [data, isSuccess, isRefetching, isLoading]);

  return [status, lawsuitCount, dataUpdatedAt, refetch];
};

export default useLawsuitCounterQuery;
